import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInbox } from '@fortawesome/free-solid-svg-icons';
import AppContext from 'context/Context';

const TicketsEmptyState = ({ filterTab, hasSearch = false }) => {
  const { config: { isDark } = {} } = useContext(AppContext);

  const getFilterMessage = () => {
    if (hasSearch) {
      return 'No se encontraron tickets con el criterio de búsqueda ingresado.';
    }
    switch (filterTab) {
      case 'pendientes':
        return 'No hay tickets pendientes en este momento.';
      case 'en_progreso':
        return 'No hay tickets en progreso actualmente.';
      case 'cerrados':
      case 'resueltos':
        return 'No hay tickets resueltos en las últimas 24 horas.';
      default:
        return 'No se encontraron tickets de soporte registrados en la base de datos.';
    }
  };

  return (
    <div
      className="border rounded-3 p-5 text-center my-3 shadow-none transition-base"
      style={{
        backgroundColor: isDark ? '#121e2d' : '#ffffff',
        borderColor: isDark ? '#233142' : '#e2e8f0'
      }}
    >
      <div
        className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
        style={{
          width: '64px',
          height: '64px',
          backgroundColor: isDark ? '#1e293b' : '#f1f5f9'
        }}
      >
        <FontAwesomeIcon
          icon={faInbox}
          style={{
            fontSize: '1.8rem',
            color: isDark ? '#64748b' : '#94a3b8'
          }}
        />
      </div>
      <h6 className="fw-bold mb-1" style={{ color: isDark ? '#f9fafd' : '#0f172a' }}>
        Sin tickets para mostrar
      </h6>
      <p className="mb-0" style={{ fontSize: '0.85rem', color: isDark ? '#94a3b8' : '#64748b' }}>
        {getFilterMessage()}
      </p>
    </div>
  );
};

export default TicketsEmptyState;
